import styled from '@emotion/styled'
import { getComponentTheme, breakpointSwitch } from '../../../__styling'

export const CardBodyWrapper = styled.div(({ theme }) => {
    const cardBodyWrapperTheme = getComponentTheme(theme, 'card')
    return [
        {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.margins.md,

            transition: 'padding 0.25s',
        },
        breakpointSwitch(cardBodyWrapperTheme.container, ({ padding }) => ({
            padding,
        })),
    ]
})
